import React from 'react';

import {HorizontalBar} from "react-chartjs-2";

const HorizontalBarChart = (props)  => {
    const dataBar = {
        labels: props.labels,
        datasets: [{
            label: props.datasetLabel,
            data: props.data,
            backgroundColor: props.bgColor || [
                'rgba(91, 79, 255, 0.8)',
                'rgba(59, 130, 246, 0.8)',
                'rgba(34, 197, 94, 0.8)',
                'rgba(245, 158, 11, 0.8)',
                'rgba(239, 68, 68, 0.8)',
                'rgba(168, 85, 247, 0.8)',
                'rgba(236, 72, 153, 0.8)',
                'rgba(20, 184, 166, 0.8)'
            ],
            borderColor: props.borderColor || [
                '#5B4FFF',
                '#3B82F6',
                '#22C55E',
                '#F59E0B',
                '#EF4444',
                '#A855F7',
                '#EC4899',
                '#14B8A6'
            ],
            borderWidth: 2,
            hoverBackgroundColor: [
                'rgba(91, 79, 255, 1)',
                'rgba(59, 130, 246, 1)',
                'rgba(34, 197, 94, 1)',
                'rgba(245, 158, 11, 1)',
                'rgba(239, 68, 68, 1)',
                'rgba(168, 85, 247, 1)',
                'rgba(236, 72, 153, 1)',
                'rgba(20, 184, 166, 1)'
            ]
        }]
    };
    return (
        <HorizontalBar
            data={dataBar}
            options={{
                maintainAspectRatio : false,
                scales: {
                    xAxes: [{
                        display: false,
                        gridLines: {
                            display: false
                        }
                    }],
                    yAxes: [{
                        display: true,
                        barThickness: 8,
                        minBarLength: 5,
                        gridLines: {
                            display: false,
                            color: 'rgba(255, 255, 255, 0.1)'
                        },
                        ticks: {
                            fontColor: 'rgba(255, 255, 255, 0.8)',
                            fontSize: 9,
                            padding: 2
                        }
                    }]
                },
                legend: {
                    "display": false
                },
                plugins: {
                    datalabels: {
                        display: true,
                        color: '#fff',
                        font: {
                            weight: 'bold',
                            size: 9
                        },
                        anchor: 'end',
                        align: 'end',
                        offset: 1
                    }
                },
                tooltips: {
                    backgroundColor: 'rgba(26, 26, 46, 0.95)',
                    titleFontColor: '#FFFFFF',
                    bodyFontColor: 'rgba(255, 255, 255, 0.9)',
                    borderColor: 'rgba(91, 79, 255, 0.5)',
                    borderWidth: 1,
                    cornerRadius: 8
                }
            }}
        />
    )
};

export default HorizontalBarChart;
